var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-button',{attrs:{"type":_vm.type},nativeOn:{"click":function($event){return _vm.copyTextToClipboard(_vm.textForCopy)}}},[_vm._t("default",function(){return [_vm._v(" Copy ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }